import React, { useRef } from 'react';
import { type StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';
import { getVideoPosterUrl } from '@/utils/videos';
import { useGetVideoUrl } from '@/hooks/useGetVideoUrl';

export interface VideoPlayerOptions {
  preload?: 'auto' | 'metadata' | 'none';
}

interface VideoPlayerProps {
  video: StudioVideo;
  options?: VideoPlayerOptions;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ video, options }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const videoUrl = `${useGetVideoUrl(video)}?${video.updatedAt}`;
  const posterUrl = getVideoPosterUrl(video);

  return (
    <div className="relative h-full w-full">
      <video
        className="absolute inset-0 h-full w-full object-cover [&::-webkit-media-controls-fullscreen-button]:hidden [&::-webkit-media-controls-fullscreen-button]:!appearance-none"
        controls
        controlsList="nofullscreen nodownload noremoteplayback noplaybackspeed noplaybackrate"
        disablePictureInPicture
        poster={posterUrl}
        ref={videoRef}
        preload={!posterUrl ? 'metadata' : options?.preload || 'none'}
      >
        <source src={`${videoUrl}${posterUrl ? '' : '#t=0.1'}`} />
      </video>
    </div>
  );
};

export default VideoPlayer;
